import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
// react-router-dom components
import { useNavigate } from "react-router-dom";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

// Authentication layout components
import IllustrationLayout from "../components";
import { useAuth0 } from "@auth0/auth0-react";
// import "react-toastify/dist/ReactToastify.css";
import { THEME_COLORS } from "constants/theme";
// import { Tab1, Tab2, Tab3, Tab4 } from "./components/tabs";
import { HelmetProvider } from "react-helmet-async";

import { getEnv } from "helpers/environment";

const getIssuerOrigin = (issuer) => {
  if (!issuer) return null;

  try {
    return new URL(issuer.includes("://") ? issuer : `https://${issuer}`).origin;
  } catch {
    return null;
  }
};

function Illustration() {
  const { themeMode } = useSelector((store) => store?.portal?.settings);
  const navigate = useNavigate();
  const { loginWithRedirect, user, isAuthenticated, isLoading } = useAuth0();
  const hasStartedAuth0Login = useRef(false);
  const [isAuth0Handoff, setIsAuth0Handoff] = useState(() => {
    const issuer = new URLSearchParams(window.location.search).get("iss");
    const issuerOrigin = getIssuerOrigin(issuer);

    return Boolean(
      issuerOrigin && issuerOrigin === getIssuerOrigin(getEnv("AUTH0_DOMAIN"))
    );
  });
  const [isSuspended, setIsSuspended] = useState(false);
  const [susMessage, setSusMessage] = useState(false);

  const loadIsUserSuspended = () => {
    const isUserSuspendedFromStorage = localStorage.getItem(`isUserSuspended`);
    const userSuspendedMsgFromStorage = localStorage.getItem(`userSuspendedMessage`);

    if (isUserSuspendedFromStorage) {
      setIsSuspended(isUserSuspendedFromStorage);
      setSusMessage(userSuspendedMsgFromStorage);
      localStorage.clear();
    }
  };
  useEffect(() => {
    loadIsUserSuspended();
  }, []);

  const handleLogin = async () => {
    try {
      await loginWithRedirect({
        appState: { returnTo: "/home" },
        authorizationParams: {
          screen_hint: "signin"
        }
      });
    } catch (error) {
      console.log(error);
    }
  };
  const handleSignUp = async () => {
    try {
      if (getEnv("ENABLE_SIGN_UP")) {
        await loginWithRedirect({
          appState: { returnTo: "/home" },
          authorizationParams: {
            screen_hint: "signup"
          }
        });
      } else {
        await loginWithRedirect({
          appState: { returnTo: "/home" },
          authorizationParams: {
            screen_hint: "signup"
          }
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (isAuthenticated && user?.email_verified) {
      navigate("/home");
    }
  }, [isAuthenticated, user]);

  useEffect(() => {
    if (
      isLoading ||
      isAuthenticated ||
      !isAuth0Handoff ||
      hasStartedAuth0Login.current
    ) {
      return;
    }

    hasStartedAuth0Login.current = true;

    loginWithRedirect({
      appState: { returnTo: "/home" },
      authorizationParams: {
        screen_hint: "signin"
      }
    }).catch((error) => {
      hasStartedAuth0Login.current = false;
      setIsAuth0Handoff(false);
      console.log(error);
    });
  }, [isAuthenticated, isAuth0Handoff, isLoading, loginWithRedirect]);

  return (
    <HelmetProvider>
      <IllustrationLayout
        hideContainer={isAuth0Handoff}
        title=""
        description=""
        illustration={{
          title: '"Attention is the new currency"',
          description:
            "The more effortless the writing looks, the more effort the writer actually put into the process."
        }}
      >
        <div id="fffd" style={{ position: "relative", top: "-80px" }}>
          <SoftBox mt={4} mb={1}>
            <SoftButton
              variant="contained"
              color="info"
              onClick={handleLogin}
              size="large"
              fullWidth
            >
              sign in
            </SoftButton>
          </SoftBox>
          <SoftBox mt={3} textAlign="center">
            <SoftTypography
              variant="button"
              fontWeight="regular"
              sx={{ color: "#000000 !important" }}
            >
              Don&apos;t have an account?{" "}
              <SoftTypography
                onClick={handleSignUp}
                variant="button"
                fontWeight="medium"
                sx={{
                  cursor: "pointer",
                  color: THEME_COLORS[themeMode.toUpperCase()].PRIMARY_FONT
                }}
                className="signUpTitle"
              >
                Sign up
              </SoftTypography>
            </SoftTypography>
          </SoftBox>
          {isSuspended && (
            <SoftBox mt={3} textAlign="center">
              <SoftTypography variant="body2" fontWeight="regular" color="error">
                {susMessage}
              </SoftTypography>
            </SoftBox>
          )}
        </div>
      </IllustrationLayout>
    </HelmetProvider>
  );
}

export default Illustration;
